module.exports = __webpack_public_path__ + "static/img/facebook.9699aeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/facebook.svg
// module id = czpo
// module chunks = 0